module.exports = __webpack_public_path__ + "static/media/MNT.3057d4c9.svg";